import * as tslib_1 from "tslib";
import getPackageBaseUrl from 'owa-session-store/lib/actions/getPackageBaseUrl';
import * as React from 'react';
import { resolve as urlResolve } from 'url';
var styles = require('./MockNotification.scss');
var classNames = require('classnames/bind').bind(styles);
var resolveImage = function (imageName) {
    return urlResolve(getPackageBaseUrl(), "resources/images/webpush-mock/" + imageName);
};
var MockNotification = /** @class */ (function (_super) {
    tslib_1.__extends(MockNotification, _super);
    function MockNotification() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MockNotification.prototype.render = function () {
        var browserIcon = this.props.browser === 'chrome' ? 'chrome.png' : 'firefox.png';
        return (React.createElement("div", { className: classNames('notification', this.props.browser, this.props.os) },
            React.createElement("div", { className: classNames('title') }, this.props.title),
            React.createElement("div", { className: classNames('body') }, this.props.body),
            React.createElement("div", { className: classNames('url') }, this.props.url),
            React.createElement("img", { className: classNames('browserIcon'), src: resolveImage(browserIcon) }),
            React.createElement("img", { className: classNames('owaIcon'), src: resolveImage('outlook.png') }),
            this.props.browser === 'chrome' &&
                this.props.os === 'windows' && (React.createElement("img", { className: classNames('browserUX'), src: resolveImage('chrome_icons.png') }))));
    };
    return MockNotification;
}(React.Component));
export { MockNotification };
//# sourceMappingURL=MockNotification.js.map